// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);
const presupuesto = new vapi({
    state: {
        list: [],
        presupuestos: [],
        tipogastos: [],
        vigencias: [],
        sectores: [],
        entidades: []
    }
}).get({
    action: "get_presupuestos",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto`;
    },
    onSuccess: (state, payload) => {
        state.list = payload.data;
    }
}).get({
    action: "get_presupuestosbypunto",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto/grouppunto`;
    },
    onSuccess: (state, payload) => {
        state.presupuestos = payload.data;
    }
}).get({
    action: "get_vigencias",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto/vigencias`;
    },
    onSuccess: (state, payload) => {
        state.vigencias = payload.data;
    }
}).get({
    action: "get_sectorspi",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto/sectores`;
    },
    onSuccess: (state, payload) => {
        state.sectores = payload.data;
    }
}).get({
    action: "get_entidadspi",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto/entidades`;
    },
    onSuccess: (state, payload) => {
        state.entidades = payload.data;
    }
}).get({
    action: "get_tipogastos",
    path: function () {
        return `${process.env.VUE_APP_REST}/api/presupuesto/tipogasto`;
    },
    onSuccess: (state, payload) => {
        state.tipogastos = payload.data;
    }
}).getStore();
presupuesto.getters = {
    gpresupuestos: state => {
        return state.presupuestos;
    },
    gtipogastos: state => {
        return state.tipogastos;
    },
    gvigencias: state => {
        return state.vigencias;
    },
    gsectoresspi: state => {
        return state.sectores;
    },
    gentidadesspi: state => {
        return state.entidades;
    },
    glistapresupuestos: state => {
        return state.list;
    },
}
export default presupuesto;